<template>
  <div class="reconcileBillDetail">
    <div class="header">对账单详情</div>
    <el-divider />

    <el-steps :space="200" :active="getActiveProcess" finish-status="success">
      <el-step :title="item.label" :key="i" v-for="(item, i) in agentBillProcessStatus" />
    </el-steps>
    <el-divider />

    <div>
      <div class="billTitle">
        <div>
          <span class="title">对账单号：{{ detailData.orderId }}</span>
          <span v-if="HE_HUO_REN && toBeConfirm" class="confirm-tip margin-l-10">
            请您3个工作日内确认账单，若逾期系统将自动确认账单
          </span>
          <el-tag
            v-if="detailData.settleProcessStr"
            class="margin-l-10"
            type="danger"
            effect="plain"
          >
            {{ detailData.settleProcessStr }}
          </el-tag>
        </div>
        <div class="btn">
          <!--        <el-button @click="auditBill(2)">撤回账单</el-button>-->
          <el-button v-if="toBeConfirm" type="primary" :loading="isLoading" @click="auditBill(1)">
            确认账单
          </el-button>
          <el-button
            type="primary"
            @click="showEditTaxRate(tableData[0])"
            v-if="UNSHOW_TAX && canEditTaxRate"
          >
            申请修改税率
          </el-button>
          <el-button v-if="HE_HUO_REN && toBeConfirm" @click="showAppealDialog">
            账单申诉
          </el-button>
          <el-button v-if="canGiveUpSettle" @click="handleGiveUpSettlement">
            放弃结算
          </el-button>
        </div>
      </div>

      <div v-if="MANAGEMENT_FEE">
        <FixPayDetail :tableData="tableData" />
      </div>

      <div class="schoolDetail" v-else-if="SCHOOL_INCOME">
        <SchoolIncomeDetail :tableData="tableData" />
      </div>

      <div v-else-if="UNSCHOOL_PARTNER">
        <UnschoolDetail :tableData="tableData" />
      </div>

      <div v-else class="billInfo">
        <!-- @source catpaw @line_count 42 @branch feature/ywh-ones-89612040 */ -->
        <div class="bill-grid">
          <div>合作商 ：{{ detailData.agentName }}</div>
          <div>业务线：{{ detailData.businessLineStr }}</div>
          <div>region：{{ detailData.regionName }}</div>
          <div>结算账期：{{ detailData.periodMonth }}</div>
          <div>
            <span>对账单状态：</span>
            <span class="ui-danger">{{ detailData.billStatusStr }}</span>
          </div>
          <div>
            <span>生成时间：</span>
            <span>{{ detailData.createTime }}</span>
          </div>
          <div>
            <span>账单总金额：</span>
            <span class="ui-danger">{{ detailData.billTotalMoney }}</span> 元
          </div>
          <div>
            <span>保证金金额：</span>
            <span>{{ detailData.bondMoney }} 元</span>
          </div>
          <div>
            <span>抵扣金额合计：{{ detailData.deductMoney }} 元</span>
            <el-button
              v-if="detailData.deductMoney"
              type="text"
              style="padding: 0"
              @click="showDeductAmount"
            >
              点击查看明细
            </el-button>
          </div>
          <div v-if="detailData.isAdjustShow">
            <span>调整金额合计：{{ detailData.adjustAmount }} 元</span>
            <el-button
              v-if="detailData.adjustAmount"
              type="text"
              style="padding: 0"
              @click="showAdjustAmountDialog"
              >点击查看明细
            </el-button>
          </div>
          <div v-if="HE_HUO_REN && toBeConfirm">
            <span>自动确认截止时间：</span>
            <span :class="detailData.autoConfirmTime && 'ui-danger'">
              {{ detailData.autoConfirmTime || '-' }}
            </span>
          </div>
          <div v-if="HE_HUO_REN">
            <span>申诉状态：</span>
            <span :class="detailData.appealStatusName && 'ui-danger'">
              {{ detailData.appealStatusName || '-' }}
            </span>
            <el-button
              v-if="detailData.appealStatusName"
              type="text"
              style="padding: 0"
              @click="showAppealDetailDialog"
            >
              详情
            </el-button>
          </div>
          <template v-if="detailData.isSaveAmountShow">
            <div>当期留存金额：{{ detailData.nowSaveAmount }} 元</div>
            <div>留存账户余额：{{ detailData.totalSaveAmount }} 元</div>
          </template>
          <div v-if="detailData.isBuyBikeDeductAmount">
            <span>平台服务费：{{ detailData.buyBikeDeductAmount }} 元</span>
          </div>
        </div>
      </div>
      <div style="text-align: right">
        <el-button
          type="primary"
          @click="auditBill(1)"
          v-if="!UNSHOW_TAX && TOBE_CONFIRM"
          :loading="isLoading"
          >确认账单
        </el-button>
      </div>

      <el-tabs v-model="activeName">
        <el-tab-pane label="结费明细" name="tab0" v-if="!MANAGEMENT_FEE">
          <el-button
            style="margin-left: 85%"
            type="primary"
            @click="billDetailExport"
            v-if="!UNSHOW_TAX"
            >导出</el-button
          >
          <div v-if="SCHOOL_INCOME">
            <SchoolIncomeTable :searchTable="searchTable" />
          </div>
          <div v-else-if="UNSCHOOL_PARTNER">
            <UnschoolTable :searchTable="searchTable" />
          </div>
          <div v-else>
            <el-table v-loading="isLoading" :data="tableData">
              <el-table-column prop="orderId" label="对账单号" width="160" fixed />
              <el-table-column prop="agentName" label="合作商名称" width="180" />
              <el-table-column prop="regionName" label="RegionName" width="120" />
              <el-table-column prop="periodMonth" label="结算账期" width="100" />
              <el-table-column v-if="HE_HUO_REN" prop="planTypeName" label="合作方案">
                <template slot-scope="{ row }">
                  {{ row.planTypeName || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="actuallyMoney" label="实收总金额" width="100" />
              <el-table-column v-if="HE_HUO_REN" prop="rate" label="分成比例(%)" width="100">
                <template slot-scope="{ row }">
                  <div
                    v-if="!isInValidData(row.rate)"
                    class="ui-danger"
                    @click="showFeeDetail(row, 'rate')"
                  >
                    {{ row.rate }}
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="adjustRate" label="调整分成比例(%)" width="120" />
              <el-table-column prop="changeMoney" label="调整金额" width="100" />
              <el-table-column prop="arrestBikeMoney" label="取扣车费用" width="100" />
              <el-table-column
                v-if="HE_HUO_REN"
                prop="partnerAmount"
                label="合作商承担费用"
                width="120"
              >
                <template slot-scope="{ row }">
                  <div
                    v-if="!isInValidData(row.partnerAmount)"
                    class="ui-danger"
                    @click="showFeeDetail(row, 'accountFee')"
                  >
                    {{ row.partnerAmount }}
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column v-if="HE_HUO_REN" prop="taxDiffAmount" label="普票税差" width="120">
                <template slot-scope="{ row }">
                  <span v-if="!isInValidData(row.taxDiffAmount) && row.taxDiffAmount !== 0">
                    {{ row.taxDiffAmount }}
                  </span>
                  <span v-else>{{ row.taxDiffAmount === 0 ? 0 : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="bikeNum" label="车辆数" width="100" />
              <el-table-column prop="managementMoney" label="平台管理费" width="100" />
              <el-table-column prop="taxRate" label="税率(%)" />
              <el-table-column prop="noTaxMoney" label="不含税金额" />
              <el-table-column prop="billTotalMoney" label="账单总金额" />
              <el-table-column prop="bondMoney" label="保证金金额" />
              <el-table-column prop="dueBondMoney" label="应交保证金总额" width="110" />
              <el-table-column prop="bondDeductionRate" label="保证金抵扣比例(%)" width="130" />
              <el-table-column prop="bondPreMoney" label="保证金期初已付金额" width="130" />
              <el-table-column prop="bondDeductionMoney" label="保证金结算已抵扣金额" width="140" />
              <el-table-column prop="bondArrearsMoney" label="保证金尚欠金额" width="110" />
              <el-table-column prop="billStatusStr" label="对账单状态" width="120" />
              <el-table-column prop="billTypeStr" label="对账单类别" />
              <el-table-column prop="createTime" label="生成时间" width="150" />
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane label="发票信息(上传发票)" name="tab1" class="invoice-info">
          <div class="billInfo">
            <el-row>
              <el-col :span="6">待审核金额 ：{{ reconcileBill.unaudittedAmount || '-' }}</el-col>
              <el-col :span="6">已开票金额：{{ reconcileBill.amountWithInvoices || '-' }}</el-col>
              <el-col :span="6"
                >待开票金额：{{ reconcileBill.amountWithoutInvoices || '-' }}</el-col
              >
              <el-col :span="6" style="text-align: right">
                <el-button
                  type="primary"
                  @click="showAddInvoice"
                  :loading="isLoading"
                  :disabled="!selectedRows.length || !canUploadInvoice"
                  >录入发票</el-button
                >
              </el-col>
            </el-row>
          </div>
          <el-table
            style="margin-bottom: 20px"
            v-loading="isLoading"
            :data="reconcileBill.invoiceList || []"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              :selectable="
                (row, index) =>
                  canUploadInvoice && ['待录入发票', '未验票已付款'].includes(row.payOrderStatus)
              "
            />
            <el-table-column prop="payOrderId" label="付款单号" fixed width="170" />
            <!--          <el-table-column prop="supplier" label="合作商名称" width="150"></el-table-column>-->
            <el-table-column prop="invoiceHeader" label="发票抬头" width="150" />
            <el-table-column prop="invoiceType" label="发票类型" width="120" />
            <el-table-column prop="amountWithTax" label="开票含税金额" width="100" />
            <el-table-column prop="taxRate" label="税率" />
            <el-table-column prop="pay" label="是否支付" />
            <el-table-column prop="payOrderStatus" label="付款单状态" />
            <el-table-column prop="invoiceSubmitted" label="是否已提交发票" width="120">
              <template slot-scope="scope">
                <span style="color: red; font-weight: bold">{{ scope.row.invoiceSubmitted }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="anticipatePayDate" label="预计付款日期" width="150" />
            <el-table-column prop="createdTime" label="生成时间" width="150" />
            <el-table-column label="操作" fixed="right" width="80">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="downloadBill(scope.row.payOrderId)"
                  :loading="isLoading"
                  :disabled="scope.row.stateDesc === '已锁定'"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <!--       已录入发票 保留-->
          <div class="billInfo">
            <el-row>
              <el-col :span="18"
                >已录入发票<span style="color: red"
                  >（*重要：发票录入完成后，请勿忘记点击“提交发票”按钮，否则影响支付进度）</span
                ></el-col
              >
              <el-col :span="6" style="text-align: right">
                <el-button type="primary" @click="getAddedInvoices">刷新验票状态 </el-button>
                <el-button
                  type="primary"
                  :disabled="!(addedInvoices || []).length"
                  @click="downloadInvoices"
                  >下载发票
                </el-button>
              </el-col>
            </el-row>
            <el-row class="margin-b-10" style="color: red">
              <el-col :span="4">发票数量：{{ passedCount || '-' }}</el-col>
              <el-col :span="6">发票含税总额：{{ passedTotalTaxAmount || '-' }}</el-col>
            </el-row>
          </div>
          <el-table v-loading="isLoading" :data="addedInvoices">
            <el-table-column prop="invoiceDate" label="开票日期" fixed width="100" />
            <el-table-column prop="invoiceCode" label="发票代码" width="120">
              <template slot-scope="{ row }">
                <span>{{
                  row.invoiceTypeCode === INVOICE_TYPE.OTHER_REIMBURSABLE ? '' : row.invoiceCode
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="invoiceNo" label="发票编号" width="120">
              <template slot-scope="{ row }">
                <span>{{
                  row.invoiceTypeCode === INVOICE_TYPE.OTHER_REIMBURSABLE ? '' : row.invoiceNo
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="verifyCode" label="校验码后6位" width="120" />
            <el-table-column prop="untaxedAmount" label="未税金额" />
            <el-table-column prop="taxRate" label="税率(%)" />
            <el-table-column prop="tax" label="税额" />
            <el-table-column prop="amount" label="含税金额" width="100" />
            <el-table-column prop="checkStatus" label="验票状态" />
            <el-table-column prop="errorMessage" label="错误信息" width="120" />
            <el-table-column prop="invoiceHeader" label="发票抬头" width="150" />
            <el-table-column prop="invoiceType" label="发票类型" width="110" />
            <el-table-column prop="payOrders" label="关联付款单" width="165" />
            <el-table-column prop="url" label="附件">
              <template slot-scope="scope">
                <a
                  v-if="scope.row.url && scope.row.url.toString().indexOf('http') > -1"
                  :href="scope.row.url"
                  target="_blank"
                  >查看</a
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :disabled="false"
                  @click="checkInvoice(scope.row)"
                  :loading="isLoading"
                  >验证发票</el-button
                >
                <el-button
                  type="text"
                  :disabled="!canUploadInvoice && scope.row.payOrderStatus !== '已取消'"
                  @click="deleteInvoice(scope.row)"
                  :loading="isLoading"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="btn-wrap">
            <div class="btn">
              <el-button
                type="primary"
                :disabled="!addedInvoices.length"
                @click="submitInvoice"
                :loading="isLoading"
                >提交发票</el-button
              >
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>

    <addInvoice
      v-if="isShowAddInvoice"
      :selectedRows="selectedRows"
      :addedInvoiceList="addedInvoices"
      :serverCheckErrors="serverCheckErrors"
      @confirm="handleAddInvoice"
    />

    <viewDeductMoney v-if="isShowDeductMoney" :orderId="orderId" />
    <BikeTableDialog
      v-bind="adjustAmountDialog"
      v-model="adjustAmountDialog.visible"
      @show="onAdjustAmountFetch"
    >
      <template #real="{ row }">
        <span :style="row.real !== row.amount ? 'color:red;' : ''">{{
          defaultCell(row.real)
        }}</span>
      </template>
    </BikeTableDialog>
    <editTaxRate
      v-if="isShowEditTaxRate"
      :visible.sync="isShowEditTaxRate"
      :curRow="curRow"
      @change="init"
    />

    <!-- 账单申诉 -->
    <AppealDialog
      v-if="appealDialogConfig.visible"
      :config="appealDialogConfig"
      :id="detailData.id"
      @update="getBillDetail"
      @close="handleDialogClose"
    />

    <!-- 申诉详情 -->
    <AppealDetailDialog
      v-if="appealDetailDialogConfig.visible"
      :config="appealDetailDialogConfig"
      :id="detailData.id"
      :statusName="detailData.appealStatusName"
      @close="handleDialogClose"
    />

    <!-- 费项详情 -->
    <FeeDetailDialog
      v-if="feeDetailDialogConfig.visible"
      :config="feeDetailDialogConfig"
      :data="detailData"
      :fundsId="feeDetailKey"
      @close="handleDialogClose"
    />

    <!-- 放弃结算 -->
    <GiveUpSettlement
      v-if="giveUpSettlementDialogConfig.visible"
      :config="giveUpSettlementDialogConfig"
      :orderNo="orderId"
      @close="handleDialogClose"
    />
  </div>
</template>

<script>
import pagination from '@/mixins/pagination'
import { addInvoice, viewDeductMoney, editTaxRate } from '@/components/reconcileBill'
import { INVOICE_TYPE } from '@/components/InvoiceEnter/default'
import { calAccountPeriod, dateFormat } from '@/utils'
import { dialogCtrl } from '@/mixins'
import { mapState } from 'vuex'
import { genAdjustAmountColumns, SETTLE_PROCESS, APPEAL_STATUS } from './constant'
// import { computeAdd } from '@/utils'
import SchoolIncomeDetail from './views/schoolIncome/detail.vue'
import SchoolIncomeTable from './views/schoolIncome/table.vue'
import FixPayDetail from './views/fixed/detail.vue'
import UnschoolDetail from './views/partnerUnschool/detail.vue'
import UnschoolTable from './views/partnerUnschool/table.vue'
import AppealDialog from './components/AppealDialog'
import FeeDetailDialog from './components/FeeDetailDialog'
import AppealDetailDialog from './components/AppealDetailDialog'
import { isInValidData } from '@bike/fe-utils'
import GiveUpSettlement from './components/GiveUpSettlement'

export default {
  name: 'reconcileBillDetail',
  components: {
    editTaxRate,
    viewDeductMoney,
    addInvoice,
    SchoolIncomeDetail,
    SchoolIncomeTable,
    FixPayDetail,
    UnschoolDetail,
    UnschoolTable,
    AppealDialog,
    FeeDetailDialog,
    AppealDetailDialog,
    GiveUpSettlement,
  },
  props: [],
  mixins: [pagination, dialogCtrl],
  data() {
    return {
      INVOICE_TYPE,
      curRow: {},
      detailData: {},
      isShowEditTaxRate: false,
      // 调整金额合计弹窗
      adjustAmountDialog: {
        title: '调整金额合计',
        // width: '1000px',
        visible: false,
        columns: genAdjustAmountColumns(),
        list: [],
      },
      billProcessStatus: 0,
      activeName: 'tab0',
      isLoading: false,
      tableData: [{}],
      serverCheckErrors: '',
      addedInvoices: [],
      varifyBillData: [],
      selTableRows: [],
      pendingInvoice: [], // 待提交发票
      selectedRows: [], // 待提交发票
      orderId: '',
      passedTotalTaxAmount: '',
      passedCount: '',
      reconcileBill: {},
      // currentOrderId: '',
      searchForm: {
        periodMonth: calAccountPeriod(new Date()),
      },
      //  确认账单数据字段，5个
      totalSum: 0,
      shareRate: 0,
      taxRate: 0,
      otherDeduction: 0,
      depositDeduction: 0,
      adjustMSum: 0,
      adjustDistrSum: 0,
      searchTable: [],
      feeDetailKey: '',
      appealDialogConfig: {
        visible: false,
        title: '账单申诉',
        width: 600,
      },
      appealDetailDialogConfig: {
        visible: false,
        title: '账单申诉详情',
        width: 600,
      },
      feeDetailDialogConfig: {
        visible: false,
        width: '80%',
      },
      giveUpSettlementDialogConfig: {
        visible: false,
        title: '放弃结算',
        width: 600,
      },
    }
  },
  computed: {
    ...mapState('reconcileBill', [
      'isShowDeductMoney',
      'isShowAddInvoice',
      'isShowImportDialog',
      'agentBillProcessStatus',
    ]),
    payOrderIds() {
      return this.selectedRows.reduce((curSum, cur) => {
        curSum.push(cur.payOrderId)
        return curSum
      }, [])
    },
    // 已选付款单含税金额总和
    // selectedRowsTotal() {
    //   return this.selectedRows.reduce((acc, cur) => acc + +cur.amountWithTax, 0)
    // },
    // 已录入发票含税金额总和
    // sumWithTaxTotal() {
    //   return this.pendingInvoice.reduce((curSum, cur) => curSum + cur.amount, 0)
    // },
    // 步骤条
    getActiveProcess() {
      for (let i = 0, len = this.agentBillProcessStatus.length; i < len; i++) {
        if (this.billProcessStatus === this.agentBillProcessStatus[i].value) {
          return i
        }
      }
      return 0
    },
    canUploadInvoice() {
      return this.billProcessStatus === 60
    },
    toBeConfirm() {
      return this.billProcessStatus === 30
    },
    canEditTaxRate() {
      return [30, 40, 50, 60].includes(this.billProcessStatus) // "已确认"、"审核中"、"发票录入/验票" "待合作商确认 和 待发送 是同一个状态"
    },
    canGiveUpSettle() {
      // settleProcess=30 或者 40 ，不展示放弃结算按钮
      const { settleProcess, businessLineStr } = this.detailData || {}
      return (
        businessLineStr === '电单车' &&
        ![SETTLE_PROCESS.GIVEUP, SETTLE_PROCESS.CANCEL].includes(settleProcess)
      )
    },
    isDev() {
      return process.env.NODE_ENV === 'development'
    },
    MANAGEMENT_FEE() {
      return this.tableData[0].billType === 51
    },
    SCHOOL_INCOME() {
      return this.tableData[0].billType === 52
    },
    TOBE_CONFIRM() {
      return this.billProcessStatus === 14
    },
    UNSCHOOL_PARTNER() {
      return [4, 5, 6].includes(this.tableData[0].billType)
    },
    UNSHOW_TAX() {
      return ![51, 52, 4, 5, 6].includes(this.tableData[0].billType)
    },
    BIKE_SCHOOL() {
      return [51, 52].includes(this.tableData[0].billType)
    },
    // 合伙人分成
    HE_HUO_REN() {
      return this.detailData.agentType === 2
    },
  },
  created() {
    this.init()
  },
  mounted() {},
  watch: {},
  methods: {
    dateFormat,
    isInValidData,
    showAdjustAmountDialog() {
      this.adjustAmountDialog.visible = true
    },
    // 调整金额
    onAdjustAmountFetch() {
      const detail = this.tableData[0] || {}
      const listStr = detail.adjustAmountStr || '[]'
      try {
        this.adjustAmountDialog.list = JSON.parse(listStr)
      } catch (err) {
        this.$message.error('adjustAmountStr 字段解析错误：', err.message)
        console.log(err)
      }
      // fetch('https://yapi.sankuai.com/mock/23398/api/agent/amount/list')
      //   .then((res) => res.json())
      //   .then((res) => {
      //     this.adjustAmountDialog.list = res.data
      //   })
      //   .finally(() => ctx.done())
    },
    async init() {
      const { orderId } = this.$route.query
      this.orderId = orderId
      this.getBillDetail()
      this.getReconcileBill()
      this.getDictMap()
      this.activeTab()
      this.getAddedInvoices()
      this.$debugVue('v_reconcileBillDetail', this)
    },
    async getDictMap() {
      const params = { businessLine: this.$route.query.businessLine }
      const res = await this.fetch.get('reconcileBill_dictMap', { params })
      if (res) {
        const { agentBillProcessStatus = {} } = res.data
        this.$store.commit(
          'reconcileBill/mu_agentBillProcessStatus',
          agentBillProcessStatus.list || []
        )
      }
    },
    showEditTaxRate(row) {
      this.curRow = row
      this.isShowEditTaxRate = true
    },
    handleGiveUpSettlement() {
      this.giveUpSettlementDialogConfig.visible = true
    },
    async auditBill(type) {
      if (type === 1 && this.detailData.appealStatus === APPEAL_STATUS.APPEALING) {
        this.$message.error('账单申诉中，无法确认账单')
        return
      }

      const {
        billTotalMoney,
        rate,
        deductMoney,
        bondMoney,
        taxRate,
        adjustRateMoney,
        changeMoney,
      } = this.tableData[0]
      this.totalSum = billTotalMoney
      this.shareRate = rate + '%'
      this.taxRate = taxRate + '%'
      this.otherDeduction = deductMoney
      this.depositDeduction = bondMoney
      this.adjustMSum = changeMoney
      this.adjustDistrSum = adjustRateMoney

      const h = this.$createElement
      let confirmMessage = []
      if (this.UNSHOW_TAX) {
        confirmMessage = [
          h(
            'p',
            { style: 'font-weight: bold' },
            '账单确认后，将进入费用提报与支付流程，请再次核对以下账单关键信息！'
          ),
          h('br'),
          h('p', null, `账单总金额：${this.totalSum}`),
          h('p', null, `分成比例：${this.shareRate}`),
          h('p', null, `开票税率：${this.taxRate}`),
          h('p', null, `其他抵扣金额：${this.otherDeduction}`),
          h('p', null, `保证金抵扣金额：${this.depositDeduction}`),
        ]
      } else if (this.BIKE_SCHOOL) {
        confirmMessage = [
          h(
            'p',
            { style: 'font-weight: bold' },
            '账单确认后，将进入费用提报与支付流程，请再次核对以下账单关键信息！'
          ),
          h('br'),
          h('p', null, `账单总金额：${this.totalSum}`),
        ]
      } else if (this.UNSCHOOL_PARTNER) {
        confirmMessage = [
          h(
            'p',
            { style: 'font-weight: bold' },
            '账单确认后，将进入费用提报与支付流程，请再次核对以下账单关键信息！'
          ),
          h('br'),
          h('p', null, `调整分成金额：${this.adjustDistrSum}`),
          h('p', null, `调整金额：${this.adjustMSum}`),
          h('p', null, `账单总金额：${this.totalSum}`),
        ]
      }
      this.$msgbox({
        title: '提示',
        type: 'warning',
        confirmButtonText: '核对无误，确认',
        showCancelButton: true,
        cancelButtonText: '取消',
        message: h('div', null, confirmMessage),
      })
        .then(async () => {
          try {
            const params = {
              orderId: this.orderId,
              auditType: type,
            }
            const res = await this.fetch.get('reconcileBill_billAudit', { params })
            if (res) {
              this.$message.success(res.message)
              this.getBillDetail()
            }
          } catch (e) {
            console.log('确认账单异常', e.errMsg)
          }
        })
        .catch(() => {})
    },
    async deleteInvoice({ invoiceNo }) {
      this.$confirm('确认删除该发票？', '提示', {
        type: 'warning',
      })
        .then(async () => {
          try {
            const params = {
              invoiceNo,
            }
            const res = await this.fetch.get('reconcileBill_deleteInvoiceHella', { params })
            if (res) {
              this.$message.success(res.message)
              this.getAddedInvoices()
            }
          } catch (e) {
            console.log('删除异常', e)
          }
        })
        .catch(() => {})
    },
    async checkInvoice(row) {
      try {
        // 填坑：后端这个接口发票抬头 是 invoiceBody
        row.invoiceBody = row.invoiceHeader

        const data = {
          orderId: this.orderId,
          payOrderIds: row.payOrders, // 英文逗号分隔的付款单ID列表
          invoices: [row],
        }
        const res = await this.fetch.post('reconcileBill_checkInvoice', data)
        if (res) {
          this.$message.success(res.message)
          this.getAddedInvoices()
        }
      } catch (e) {
        console.log('验证异常', e)
      }
    },
    async submitInvoice() {
      // 发票状态校验
      if (this.addedInvoices.some(row => !['验票通过', '自动验票通过'].includes(row.checkStatus))) {
        this.$message.error(
          '有发票验证未通过不允许提交。重试「验证发票」操作，或「删除」发票后重新录入'
        )
        return
      }
      try {
        this.isLoading = true
        const params = {
          orderNo: this.orderId,
        }
        const res = await this.fetch.get('reconcileBill_submitInvoiceHella', { params })
        if (res) {
          this.$message.success('发票提交成功，纸质发票请尽快邮寄')
          this.getReconcileBill()
          this.getAddedInvoices()
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        console.log('提交发票异常', e)
      }
    },
    showDeductAmount() {
      this.$store.commit('reconcileBill/mu_isShowDeductMoney', true)
    },
    async addInvoice() {
      try {
        // 需要验证录入的多张发票的含税金额汇总=勾选的付款单含税金额之和（误差允许1元以内）
        // 否则报错"发票金额与付款单金额不匹配"
        // if (Math.abs(this.sumWithTaxTotal - this.selectedRowsTotal) > 1) {
        //   return this.$message.error('发票金额与付款单金额不匹配')
        // }

        const data = {
          invoices: this.pendingInvoice,
          payOrder: this.payOrderIds.join(','),
        }
        const res = await this.fetch.post('reconcileBill_confirmInvoiceHella', data)
        if (res.message === 'success') {
          this.$message.success(res.message)
          this.hideDialog('reconcileBill/mu_isShowAddInvoice')
          this.getAddedInvoices()
        } else {
          // 异常时回显在录入弹框
          this.serverCheckErrors =
            Math.random()
              .toString()
              .slice(0, 9) + res.message
        }
      } catch (e) {
        console.log('e', e.errMsg)
      }
    },
    async getAddedInvoices() {
      try {
        const params = {
          orderNo: this.orderId, // 对账单号
        }
        const res = await this.fetch.get('reconcileBill_getInvoiceHella', { params })
        const { invoiceList, passedCount, passedTotalTaxAmount } = res.data || {}
        this.addedInvoices = invoiceList || []
        this.passedCount = passedCount
        this.passedTotalTaxAmount = passedTotalTaxAmount
      } catch (e) {
        console.log('e', e.errMsg)
      }
    },
    downloadInvoices() {
      const idList = this.addedInvoices.map(item => item.id)
      const params = {
        idListString: idList.join(),
      }
      this.downloading = true
      this.fetch
        .get('settlementDownloadInvoice', { params })
        .then(res => {
          this.downloading = false
          if (res.data) {
            window.downloadFile(res.data)
          }
        })
        .catch(() => {
          this.downloading = false
        })
    },
    handleSelectionChange(rows) {
      this.selectedRows = JSON.parse(JSON.stringify(rows))
    },
    handleAddInvoice(invoice) {
      this.pendingInvoice = invoice
      this.addInvoice()
    },
    async getBillDetail() {
      const params = {
        orderId: this.orderId,
      }
      try {
        const res = await this.fetch.get('reconcileBill_BillDetail', { params })
        if (res && res.data) {
          this.detailData = res.data
          this.tableData = [res.data]
          this.searchTable = res.data.details
          this.billProcessStatus = res.data.billProcessStatus
        }
      } catch (err) {
        this.$addOwlError({
          name: `【账单列表-对账单查询-详情】获取对账单详情失败_${err.message}`,
          msg: { err, params },
        })
      }
    },
    // 获取 发票信息tab下 第一个tabel的数据
    async getReconcileBill(type = '') {
      const params = {
        orderNo: this.orderId,
      }
      const res = await this.fetch.get('reconcileBill_getPayOrdersHella', { params })
      if (res) {
        if (type === 'refresh') {
          this.reconcileBill.unaudittedAmount = res.data.unaudittedAmount
          this.reconcileBill.amountWithInvoices = res.data.amountWithInvoices
          this.reconcileBill.amountWithoutInvoices = res.data.amountWithoutInvoices
        } else {
          this.reconcileBill = res.data
        }
      }
    },
    showAddInvoice() {
      // 不同法人名称、不同税率、不同发票类型不允许同时勾选开票
      for (let i = 0; i < this.selectedRows.length; i++) {
        if (i === 0) continue
        if (
          this.selectedRows[i].invoiceHeader !== this.selectedRows[i - 1].invoiceHeader ||
          this.selectedRows[i].taxRate !== this.selectedRows[i - 1].taxRate ||
          this.selectedRows[i].invoiceType !== this.selectedRows[i - 1].invoiceType
        ) {
          return this.$message.error('不同法人名称、不同税率、不同发票类型不允许同时勾选开票')
        }
      }
      this.showDialog('reconcileBill/mu_isShowAddInvoice')
    },
    async downloadBill(payOrderId) {
      const params = {
        orderNo: payOrderId,
      }
      const res = await this.fetch.get('reconcileBill_billPrint', { params })
      if (res) {
        window.open(res.data)
      }
    },
    defaultCell(value) {
      if (value === undefined || value === null || value === '') {
        return '-'
      }
      return value
    },
    activeTab() {
      // 后期维护路由跳转传参时，注意这里可能需要修改
      const arr = window.location.href.split('&')
      const billType = arr[arr.length - 1]
      if (billType.split('=')[1] === 51) {
        this.activeName = 'tab1'
      } else {
        this.activeName = 'tab0'
      }
    },
    // 费用明细导出
    billDetailExport() {
      const params = {
        orderId: this.orderId,
      }
      this.exportLoading = true
      this.fetch
        .get('reconcileBill_schoolExport', { params })
        .then(res => {
          if (res.data) {
            window.downloadFile(res.data)
          }
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },

    /**
     * 查看费项详情
     * @param {string} key 费项key
     */
    showFeeDetail(row, key) {
      if (row.isOldFlag) return // 旧账单不弹窗

      this.feeDetailKey = key
      this.feeDetailDialogConfig.visible = true
    },

    // 申诉详情
    showAppealDetailDialog() {
      this.appealDetailDialogConfig.visible = true
    },

    // 账单申诉
    showAppealDialog() {
      this.appealDialogConfig.visible = true
    },

    handleDialogClose(isRefresh = false) {
      this.appealDialogConfig.visible = false
      this.appealDetailDialogConfig.visible = false
      this.feeDetailDialogConfig.visible = false
      this.giveUpSettlementDialogConfig.visible = false

      if (isRefresh) {
        this.getBillDetail()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.invoice-info {
  .btn-wrap {
    margin-top: 10px;
    display: flex;
    flex-direction: row-reverse;
  }
}
.billTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  .title {
    font-size: 16px;
    font-weight: bold;
  }
}
.billInfo {
  font-size: 14px;
  margin-bottom: 18px;
  .bill-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    > div {
      box-sizing: border-box;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
<style lang="scss">
button.el-button.el-button--default.el-button--primary.confirmButton_batch {
  background-color: rgb(255, 209, 0);
  &:hover {
    background-color: rgb(255, 209, 0);
  }
}
</style>
